import { atom, getDefaultStore } from 'jotai/vanilla';
import Fuse from 'fuse.js';

export const institutions = {
  primitives: {
    list: atom<string[]>([]),
    search_key: atom<string>(''),
  },
  fetch: atom(async () => {
    const assetHost =
      process.env.VITE_MODE === 'development'
        ? ''
        : `${process.env.VITE_ASSET_HOST}/${process.env.VITE_BUCKET_FOLDER}`;

    const response = await fetch(assetHost + '/world_universities_and_domains.json');
    const json = await response.json();
    const result: string[] = [
      ...new Set(
        json.reduce((acc, institution) => {
          if (['US', 'MX', 'GB', 'CA'].includes(institution.alpha_two_code))
            return [...acc, institution.name];
          return acc;
        }, []) as string[],
      ),
    ];
    return result as string[];
  }),
  search: atom(
    (get): string[] => {
      const search_key = get<string>(institutions.primitives.search_key);
      const list = get<string[]>(institutions.primitives.list);
      if (search_key === '') return list;
      const fuse = new Fuse(list);
      return fuse.search(search_key).map((result) => result.item);
    },
    (get, set, name: string) => {
      set(institutions.primitives.search_key, name);
    },
  ),
};

institutions.primitives.list.onMount = (set) => {
  const store = getDefaultStore();
  store.get(institutions.fetch).then((list) => set(list));
};
